import { Image, Switch, Tag } from "@chakra-ui/react";
import { getTenantTipoName } from "core/features/tenants/helpers";
import useToggleTenantStatus from "core/features/tenants/hooks/useToggleTenantStatus";
import {
  TenantPaginateResponse,
  TenantStatus,
} from "core/features/tenants/typings/tenant";
import { showErrorAxios } from "infra/helpers/alerta";
import { useCallback, useMemo } from "react";

function useTenantListagemColumns() {
  const { mutate: handleToggleStatus } = useToggleTenantStatus();

  const _handleToggleStatus = useCallback(
    (tenantId: string, checked: boolean) => {
      const newStatus = checked ? TenantStatus.Ativo : TenantStatus.Inativo;
      handleToggleStatus(
        {
          tenantId,
          status: newStatus,
        },
        {
          onError: (err) => {
            showErrorAxios(
              err,
              "Não foi possível alterar o status do condomínio."
            );
          },
        }
      );
    },
    [handleToggleStatus]
  );

  return useMemo(() => {
    return [
      {
        title: "",
        render: (item: TenantPaginateResponse) => {
          return item.imagemUrl ? (
            <Image src={item.imagemUrl} rounded="full" h="35px" />
          ) : null;
        },
      },
      {
        title: "Nome",
        dataIndex: "nome",
      },
      {
        title: "",
        render: (item: TenantPaginateResponse) => {
          return <Tag>{getTenantTipoName(item.tipoTenantId)}</Tag>;
        },
      },
      {
        title: "Status",
        render: (original: TenantPaginateResponse) => {
          const isChecked =
            original.status.id?.toLowerCase() ===
            TenantStatus.Ativo.toLowerCase();

          return (
            <div>
              <Switch
                onChange={() => _handleToggleStatus(original.id, !isChecked)}
                isChecked={isChecked}
              />
            </div>
          );
        },
      },
    ];
  }, [_handleToggleStatus]);
}

export default useTenantListagemColumns;
